import placeholder from '../../images/pd-resource-square.png';
import React, { useEffect } from 'react';
import CheckIcon from '@mui/icons-material/Check';

export const ImageStack = ({ file, alt, count, badge, percentage, size = 'size-35', title, className = '' }) => {
  const [gradient, setGradient] = React.useState('conic-gradient(transparent 0, white 0)');
  const [showPercentage, setShowPercentage] = React.useState(false);
  const [roundedPercentage, setRoundedPercentage] = React.useState(0);

  async function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    const inner = async () => {
      const rounded = Math.round(percentage);

      if (!percentage || percentage === 0 || percentage === undefined || isNaN(percentage)) {
        return;
      }
      setShowPercentage(true);
      setRoundedPercentage(rounded);
      if (percentage > 0 && percentage < 100) {
        let transition = roundedPercentage > 0 ? roundedPercentage : 1;
        setGradient(`conic-gradient(transparent ${transition}%, white 0)`);
        while (transition <= rounded) {
          setGradient(`conic-gradient(transparent ${transition}%, white 0)`);
          transition += 0.5;
          await delay(rounded - transition > 30 ? 5 : 15);
        }
      } else if (percentage === 100) {
        setGradient('transparent');
      }
    };
    inner();
  }, [percentage]);

  return (
    <div className={`group relative row-span-2 aspect-square ${size} ${className}`} title={title}>
      {count > 2 && (
        <div className="absolute top-2 -left-4 h-full w-full origin-bottom-left -rotate-10 rounded-2xl border-1 border-gray-200 bg-white p-2 shadow-md transition-[rotate] group-hover:-rotate-13">
          <img className="rounded-lg" src={file ? `${process.env.REACT_APP_API_URL}/${file}` : placeholder} alt={alt} />
        </div>
      )}
      {count > 1 && (
        <div className="absolute top-1 -left-2 z-10 h-full w-full origin-bottom-left -rotate-5 rounded-2xl border-1 border-gray-200 bg-white p-2 shadow-md transition-[rotate] group-hover:-rotate-6">
          <img className="rounded-lg" src={file ? `${process.env.REACT_APP_API_URL}/${file}` : placeholder} alt={alt} />
        </div>
      )}
      <div
        className="data-[percentage=true]:bg-pdteal/70 relative z-20 h-full w-full rounded-2xl border-gray-200 bg-white p-2 shadow-md transition-[conic-gradient] data-[percentage=false]:border-1"
        data-percentage={showPercentage}
        style={{
          background: `${gradient}`
        }}
      >
        <img
          className="h-full w-full rounded-lg"
          src={file ? `${process.env.REACT_APP_API_URL}/${file}` : placeholder}
          alt={alt}
        />
      </div>
      {badge && (
        <div className="bg-pddarkblue absolute -top-1 -right-2 z-30 flex size-8 items-center justify-center rounded-full text-lg font-semibold text-white">
          {count}
        </div>
      )}
      {percentage < 100 && (
        <div className="bg-pdteal absolute bottom-2 left-1/2 z-30 -translate-x-1/2 translate-y-1/2 rounded-lg p-1 text-xl font-bold text-white shadow-md">
          {roundedPercentage}%
        </div>
      )}
      {percentage === 100 && (
        <div className="bg-pdteal absolute bottom-2 left-1/2 z-30 -translate-x-1/2 translate-y-1/2 rounded-full p-1 text-xl font-bold text-white shadow-md">
          <CheckIcon className="size-7"></CheckIcon>
        </div>
      )}
    </div>
  );
};
